import { notificationsActionTypes } from './notifications.types';

export const syncRequested = () => ({
    type: notificationsActionTypes.NOTIFICATIONS_SYNC_REQUESTED,
});

export const synced = (items) => ({
    type: notificationsActionTypes.NOTIFICATIONS_SYNCED,
    payload: { items },
});

export const notificationReceived = (item) => ({
    type: notificationsActionTypes.NOTIFICATION_RECEIVED,
    payload: { item },
});

export const markRead = (notificationId) => ({
    type: notificationsActionTypes.NOTIFICATION_MARK_READ,
    payload: { notificationId },
});

export const notificationsReset = () => ({
    type: notificationsActionTypes.NOTIFICATIONS_RESET,
});
